import type { Company, SpecialHandlingNote } from './types';

const STOP = new Set(['LLC', 'INC', 'LTD', 'CO', 'CORP', 'THE', 'OF', 'AND']);

/** Short upper-case company code (≤ 6 chars): initials of the significant words, or the first word for one-word names. */
export function companyCode(name: string): string {
  const words = name.toUpperCase().replace(/[^A-Z0-9 ]/g, ' ').split(/\s+/).filter((w) => w && !STOP.has(w));
  if (words.length === 1) return words[0]!.slice(0, 6);
  return words.map((w) => w[0]).join('').slice(0, 6);
}

export function activeSpecialHandling(company: Pick<Company, 'specialHandlingNotes'>): SpecialHandlingNote[] {
  return (company.specialHandlingNotes ?? []).filter((n) => n.active);
}
